export default {
  PersonalTagType: "Persönliche Tags",
  ProjectTagType: "Projekt-Tags",
};
